import React, { useState, useEffect } from "react";
import {PulseLoader } from "react-spinners";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { PropaneSharp } from "@mui/icons-material";
const Steptwo = (props) => {

   useEffect(() => {
      window.scrollTo(0,0)
  }, []);

  function RadomBarberPicker()
  {
    var ranNum = Math.floor(Math.random() * (props.barbers.length))
    props.handleBarberSelected(props.barbers[ranNum]);
    props.getBarberWorkingDays(props.barbers[ranNum].barberId);
    props.goTo(2);
  }
  console.log(props.barbers)
  return (
       <div className="booking-portal-step-wrapper">
        <section>
          <div className="grid-wrapper">
            <h2 style={{marginBottom:0, marginLeft:"auto", marginRight:"auto"}} className="grid-title">Choose A Person</h2>


            <div className="service-grid">
              {props.barbers == 'waiting' ?
            <div style={{marginLeft:"auto", marginRight:"auto"}}>
         <div style={{marginTop:"2rem", marginLeft:"auto"}}>  
                <PulseLoader 
                  color={'#333'}
                  loading={props.barbers == 'waiting'}
                  size={25}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            </div>
              :
              
             props.barbers.length === 0 ? 
             <div style={{width:"100%"}}>
              <div>
            <IconButton aria-label="delete" size="large">
              <ArrowBackIcon className="back-arrow" onClick={() => {props.goTo(0); props.setBarberData("waiting")}} />
            </IconButton>
            </div>
              <div className="service-info" style={{width:"100%", display:"flex"}}>
                <p style={{marginLeft:"auto", marginRight:"auto"}}>No barbers</p>
              </div>
              </div>
              :
             <div style={{marginLeft:"auto", marginRight:"auto"}}>
              {console.log(props.barbers)}
                          <IconButton aria-label="delete" size="large">
              <ArrowBackIcon className="back-arrow" onClick={() => {props.goTo(0); props.setBarberData("waiting")}} />
            </IconButton>
       <div className="service-grid">
         {props.barbers.map((barber, index) => (
           <div onClick={() => {props.handleBarberSelected(barber); props.goTo(2); props.getBarberWorkingDays(barber.barberId);}} className="service-card-grid" key={index}>
             <img
               src={process.env.REACT_APP_API_SERVICE_BASE_URL+'image/' + "BarberProfileImages/" + barber.filename}
               className="grid-image"
             />
             
             <p className="grid-title-text">{barber.name}</p>
           </div>
         ))}


       </div>
                   <div onClick={() => {RadomBarberPicker();}} className="service-card-grid" style={{marginLeft:"auto", marginRight:"auto", marginTop:"2rem"}}>
             <p style={{padding:"0.3rem"}} className="grid-title-text">Pick For Me</p>
           </div>
            </div>     
        }
        </div>
        </div>
      </section>
    </div>

  );
};

export default Steptwo;

